export default __webpack_public_path__ + "static/media/prezentacia.34826d8d.pdf";